/**
 * Feature Flag Definitions
 *
 * Static feature flag configuration for the app.
 */

import type { AppFeature } from './types';

/**
 * Application feature flags.
 */
export const features: AppFeature[] = [
  {
    id: 'graphqlFetch',
    name: 'GraphQL - Raw Fetch',
    description: 'Enable /graphql-poc/fetch route for raw fetch-based GraphQL client',
    category: 'experimental',
    criteria: [
      { environment: ['local', 'development'] },
    ],
  },
  {
    id: 'graphqlGraphqlRequest',
    name: 'GraphQL - graphql-request',
    description: 'Enable /graphql-poc/graphql-request route for graphql-request library',
    category: 'experimental',
    criteria: [
      { environment: ['local', 'development'] },
    ],
  },
  {
    id: 'graphqlUrql',
    name: 'GraphQL - urql',
    description: 'Enable /graphql-poc/urql route for urql library',
    category: 'experimental',
    criteria: [
      { environment: ['local', 'development'] },
    ],
  },
  {
    id: 'graphqlApollo',
    name: 'GraphQL - Apollo',
    description: 'Enable /graphql-poc/apollo route for Apollo Client',
    category: 'experimental',
    criteria: [
      { environment: ['local', 'development'] },
    ],
  },
];

export default features;
